export default __webpack_public_path__ + "static/media/Andrea.790e6f10.jpeg";